/*
 * @Author: 317473294@qq.com
 * @Date: 2023-05-24 10:27:20
 * @LastEditTime: 2023-10-22 13:54:53
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/api/user.js
 */
//导入请求拦截与响应拦截，每次请求，都会经过请求拦截，请求结束会产生响应拦截，
import Axios from "../axios"

//登录接口
export function login(data){
    return Axios({
        method:"post",
        url:"api/login",
        data:data
    })
}
//拉取所有用户数据
export function getAllUser(data){
    return Axios({
        method:"get",
        url:"api/getAllUser",
        params:data
    })
}
//获取当前用户
export function getCurrentUser(data){
    return Axios({
        method:"get",
        url:"api/getCurrentUser",
        data:data
    })
}
//更新登录用户个人数据
export function updateUser(data){
    return Axios({
        method:"patch",
        url:"api/update",
        data:data
    })
}
//更新选择任意一个用户数据
export function selectUserUpdate(data){
    return Axios({
        method:"patch",
        url:"api/selectUserUpdate",
        data:data
    })
}
//创建新用户
export function createUser(data){
    return Axios({
        method:"post",
        url:"api/create",
        data:data
    })
}
//删除用户
export function deleteUser(data){
    return Axios({
        method:"delete",
        url:"api/deleteUser",
        data:data
    })
}
//搜寻用户
export function vogueFindUser(data){
     return Axios({
        method:'post',
        url:'api/getVogueUsername',
        data:data
    })
}



// WEBPACK FOOTER //
// ./src/api/user.js